// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__13qbu","navText":"Navbar_navText__30385","navLogo":"Navbar_navLogo__8fcFV","imgLogo":"Navbar_imgLogo__3TpNa"};